/*
 * @Author: Administrator
 * @Date:   2018-07-16 09:52:34
 * @Last Modified by: maoyanping
 * @Last Modified time: 2020-07-17 11:40:52
 */
var href = window.location.href;
var protocol = window.location.protocol;
var host = window.location.host;
var urlHead = protocol + "//" + host;

/*代理*/
var urlPk = urlHead + '/api/';
var urlLogin = urlHead + '/login/';
var urlImg = urlHead + '/img/';


//baseUrl
export const getInfo = () => urlLogin + 'admin/user/front/info';
export const uploadIotExper = () => urlImg + 'oss/uploadIotExper';

//login
export const login_url = () => urlLogin + 'auth/oauth/token';
// export const login_url = () => urlPk + 'chargeuser/oauth/token';

//menu
export const menu_url = () => urlLogin + 'admin/user/front/menus';
//日志管理
export const getconlog = () => urlLogin + "admin/loginLog/page";
export const getOperationLog = () => urlLogin + "admin/gateLog/page";
/*停车管理*/

export const getUnbindEquip = () => urlPk + 'parking/onerankdev/querySpaceUnbindOnerankdevByDevtypeAndSpaceId';

export const qrCode = () => urlPk + 'parking/position/generate_qr_code'; //二维码，未使用

export const parkingBusType = () => urlPk + 'parking/parkingBusinessType/all';

export const dictValue = () => urlPk + 'dict/dictValue/type';
export const getCity = () => urlPk + 'parking/citys/page';

//export const parkList = () => urlPk + 'parking/parking/queryParkingByRole';
/**author:mao date:2019-09.26 content:修改车场接口 */
export const parkList = () => urlPk + 'parking/parking/page';
// export const parkList = () => urlPk + 'parking/parking/queryParkingByRoleNew';
/**author:mao date:2019-09.26 content:修改车场接口 */
export const parkAdd = () => urlPk + 'parking/parking';
// 车场管理删除
export const deletePark = () => urlPk + 'parking/parking/removeParking';

export const getParkSingle = () => urlPk + 'parking/parking/one';


export const getRulesType = () => urlPk + 'charge/chargeRulesType/all';
export const addOrUpdateChargeRuleByTimeQuantum = () => urlPk + 'charge/chargeRulesType/addOrUpdateChargeRule';
export const getChargeRuleByTimeQuantum = () => urlPk + 'charge/chargeRulesType/queryByIdAndParkingId';
// 收费规则
export const addOrUpdateChargeRule = () => urlPk + 'charge/chargeRules';
export const getChargeRule = () => urlPk + 'charge/chargeRules/one';
export const getChargeRuleF = () => urlPk + 'charge/chargeRules/{id}';



//路边停车泊位树
export const getAllDatas = () => urlPk + 'parking/baseDept/roadsideTreeByArea'; //获取所有停车场，岗位，停车位
//路边停车网关树
export const gatewayTree = () => urlPk + "parking/baseDept/roadsideTreeByStation";
//停车场树
export const getDepartTree = () => urlPk + 'parking/baseDept/onsiteTree';
//共享停车树
export const getShareParkTree = () => urlPk + 'parking/baseDept/onsiteTreeShare';

export const getArea = () => urlPk + 'parking/parkingArea/page';
// export const getArea = () => urlPk + 'parking/parkingArea/queryPageAreaByParkingAndAreaIdOrName'; //获取岗位信息
export const getAreaAllData = () => urlPk + 'parking/parking/queryComponentDataByAreaid'; //获取每个岗位的车位信息
export const getAreaSingle = () => urlPk + 'parking/parkingArea/one';
export const addEditArea = () => urlPk + 'parking/parkingArea';
export const getAllParkingsByEnabled = () => urlPk + 'parking/parking/allByEnabled';
// export const getAllAreasByConditions = () => urlPk + 'parking/parkingArea/allByConditions';//暂未使用
export const getOnePark = () => urlPk + 'parking/parking/one';

/**2019.08.22修改 */
// export const getOneSpace = () => urlPk + 'parking/parkingSpace/mergeOne';
export const getOneSpace = () => urlPk + 'parking/parkingSpace/querySpace';

export const getAllSpaces = () => urlPk + 'parking/parkingSpace/queryAllSpaceByIdOrName'; //查询所有车位
export const getAllAreas = () => urlPk + 'parking/parkingArea/queryAllAreaByParkingAndAreaIdOrName'; //查询所有岗位信息
export const getAllIOList = () => urlPk + 'parking/lotMsg/queryAllByAearIdAndIoTime'; //查询所有进出记录

//export const getSpaceByArea = () => urlPk + 'parking/parkingSpace/queryPageSpaceByIdOrNameOrNum'; //泊位图表使用

export const getSpaceByArea = () => urlPk + 'parking/parkingSpace/querySpaceByIdOrNameOrNum'; //泊位图表使用

export const moveSpace = () => urlPk + 'parking/parkingSpace/moveParkingSpace'; //移动车位

// 泊位删除
export const delSpace = () => urlPk + 'parking/parkingSpace/remove';


export const addEditSpace = () => urlPk + 'parking/parkingSpace';
export const getSpaceSingle = () => urlPk + 'parking/parkingSpace/one';
// export const getSpaceSingle = () => urlPk + 'parking/parkingSpace/querySpace';

//export const getAllSpace = () => urlPk + 'parking/parkingSpace/page';
export const getSpaceList = () => urlPk + 'parking/parkingSpace/queryPageSpaceByIdOrName';
/**
 * date:2019.03.14
 * content：将分页列表接口换成parking/parkingSpace/page
 */
// export const getSpaceList = () => urlPk + 'parking/parkingSpace/page';
export const addEditIo = () => urlPk + 'parking/parkingIo';
export const getIoSingle = () => urlPk + 'parking/parkingIo/one';

export const addEditComp = () => urlPk + 'parking/parkingComponent';
export const getCompSingle = () => urlPk + 'parking/parkingComponent/one';
export const addDataComp = () => urlPk + 'parking/parkingComponentData';
export const getDataSingle = () => urlPk + 'parking/parkingComponentData/one';

export const getSpaceBindEquip = () => urlPk + 'parking/onerankdev/queryOnerankdevBySpaceid';
export const getSpaceEquip = () => urlPk + 'parking/onerankdev/querySpaceUnBindDev';
// export const spaceBindEquip = () => urlPk + 'parking/spaceOnerankde';
/**
 * date:2019.03.14
 * content：更改地磁和泊位绑定的接口
 */
export const spaceBindEquip = () => urlPk + 'parking/spaceOnerankde/BindingOnerankde';
export const spaceUnbindEquip = () => urlPk + 'parking/onerankdev/deleteBindDev';

export const getIoBindEquip = () => urlPk + 'parking/onerankdev/queryBindOnerankdevByIoid';
export const getIoEquip = () => urlPk + 'parking/onerankdev/queryIoUnBindDev';
export const ioBindEquip = () => urlPk + 'parking/ioOnerankde';
export const ioUnbindEquip = () => urlPk + 'parking/ioOnerankde/deleteIoOnerankde';

//获取车场下的高位视频
export const fetchHighVideoList=()=>urlPk + 'parking/intellidataDevice/highOrderVideo';

// export const searchArea = () => urlPk + 'parking/parkingSpace/querySpaceByParkingIdAndAreaName'; //根据岗位搜索车位，暂未使用

export const getGeomagnetismsList = () => urlPk + 'parking/onerankdev/querySpaceUnbindOnerankdevByStationId'; //根据网关获取未使用地磁列表

//根据市获取区/县
export const getAllCounty = () => urlPk + 'parking/citys/page';


//人员
export const getRoleStaff = () => urlPk + 'admin/depart/user';
export const getParkStaff = () => urlPk + 'parking/userParking/userParkingBypage';
export const bindUser = () => urlPk + 'parking/userParking/addUserParkingRole';
export const unBindUser = () => urlPk + 'parking/userParking';
export const getRefundMessage = () => urlPk + 'parking/userMessage/page';
export const acceptRefund = () => urlPk + 'parking/parkingOrders/orderRefund';
export const refuseRefund = () => urlPk + 'parking/userMessageRs/refundFeedback';


//审核管理
export const getCheckList = () => urlPk + 'parking/plateAuditRecord/page';
export const checkPlate = () => urlPk + 'parking/plateAuditRecord/plateAudit';

export const getPrivateList = () => urlPk + 'parking/privateLotAuditRecord/page';
export const getPrivateSingle = () => urlPk + 'parking/privateLotAuditRecord/one';
export const delPrivate = () => urlPk + 'parking/privateLotAuditRecord';

//账户管理
export const getCarUserList = () => urlPk + 'parking/appUser/page';
export const getLicense = () => urlPk + 'parking/plate/getUserPlateList';
export const delUser = () => urlPk + 'parking/appUser';

export const addManager = () => urlPk + 'admin/user/saveOrUpdateUser';
export const getAllRole = () => urlPk + 'parking/depart/queryDepartRole';
export const getManagerList = () => urlPk + 'parking/depart/queryUserByRole';

export const delRole = () => urlPk + 'admin/user';

//反馈
export const getHandsetList = () => urlPk + 'parking/abnormalFeedback/page';
export const getHandsetByReportingId=()=>urlPk + 'parking/abnormalFeedback';
export const getHandsetSingle = () => urlPk + 'parking/abnormalFeedback/one';
export const dealHandset = () => urlPk + 'parking/abnormalFeedbackRs/haddleSpaceErrRecord';

export const getAppList = () => urlPk + 'parking/userFeedback/page';

export const getMagneticList = () => urlPk + 'parking/spaceExceptionProceRecord/page';
export const getMagneticSingle = () => urlPk + 'parking/spaceExceptionProceRecord/one';
export const dealMagnetic = () => urlPk + 'parking/spaceExceptionProceRecordRS';

//订单
export const getOrderList = () => urlPk + 'parking/parkingOrders/queryOrderByPage';
export const getAllOrderStatus = () => urlPk + 'dict/dictValue/type/order_status';
export const getAllPayTypes = () => urlPk + 'dict/dictValue/type/pay_type';
export const delOrder = () => urlPk + 'parking/parkingOrders/removeOrderById';
export const clearOrder = () => urlPk + 'parking/parkingOrders/cancel';
export const reqModifyPlate= () => urlPk + 'parking/parkingOrders/modifyPlate';

// 订单详情
export const queryOrderByPageExt = () =>
  urlPk.concat('parking/parkingOrders/queryOrderByPageExt');
export const queryFeedbackByOrderNum = () =>
  urlPk.concat('parking/abnormalFeedback/queryByOrderNum');
export const queryAlarmLogByOrderNum = () =>
  urlPk.concat('parking/alarmLogHistory/queryByOrderNum');

//逃费车辆
export const getOrderListFee = () => urlPk + 'parking/parkingOrders/queryEscapeFeeCar';
//咨询
export const addConsultList = () => urlPk + 'parking/parkingAdvisory';
export const getConsultList = () => urlPk + 'parking/parkingAdvisory/page';
export const getConsultSingle = () => urlPk + 'parking/parkingAdvisory/one';

//进出场管理
export const getIORecordList = () => urlPk + "parking/lotMsg/queryPageByAearIdAndIoTime";
export const delIORecord = () => urlPk + "parking/lotMsg";

//设备管理
export const getDirectiveList = () => urlPk + "parking/onerankdevOrder/queryOnerankdevOrderByParkOrAreaOrSpace";

// export const getStatusList = () => urlPk + "parking/onerankdevStatusChange/queryOnerankdevStatusChangeByParkOrAreaOrSpace";

// export const getHeatbeatList = () => urlPk + "parking/onerankdevHeart/queryOnerankdevHeartByParkOrAreaOrSpace";

export const getAllStatusList = () => urlPk + "parking/onerankdevStatusChange/all";

export const getAllEquipList = () => urlPk + "parking/onerankdev/queryAllByIdOrName";

export const getAllDevHeartList = () => urlPk + "parking/onerankdevHeart/all";

export const getAllOrderList = () => urlPk + "parking/onerankdevOrder/all";

export const getEquipList = () => urlPk + "parking/onerankdev/queryPageByIdOrName";

// export const getEquipList = () => urlPk + "parking/stationOnerankde/page";

export const getOneEquip = () => urlPk + "parking/onerankdev/getOneById";

export const addEquip = () => urlPk + "parking/onerankdev/saveOnerankdevNew";

export const editEquip = () => urlPk + "parking/onerankdev/updateOnerankdev";

export const delEquip = () => urlPk + "parking/onerankdev/removeOnerankdev";

export const allEquipStatus = () => urlPk + "dict/dictValue/type/error_type";

export const getStationList = () => urlPk + "parking/station/page";

export const addStation = () => urlPk + "parking/station";

export const editStation = () => urlPk + "parking/station/updateStation";

export const removeStation = () => urlPk + "parking/station/removeStation";

export const getAllStationList = () => urlPk + "parking/station/queryAllByEnabled";

export const setHeartTime = () => urlPk + "parking/station/stationHeartTime";

export const correct = () => urlPk + "parking/onerankdev/ornerankdevExamine";

export const lowerEquip = () => urlPk + "parking/station/stationRelevancyOkv";

export const bulkLoad = () => urlPk + "parking/parking/bulkLoad/parkingSpace";

export const greater50 = () => urlPk + "parking/station/stationRelevancyOkvNum";

//导入设备
export const exportNBequip = () => urlPk + "parking/nbOnerankdev/importExcelThread";


/**author:mao date:2019.09.23 content:报警列表*/
// export const equipWarn= () => urlPk + "parking/monitoringAlarm/queryPageByIdOrName";
// export const equipWarn= () => urlPk + "parking/alarmMonitoring/queryPageByIdOrName";
export const equipWarn = () => urlPk + "parking/nbOnerankdev/alarm";
/**author:mao date:2019.09.23 content:报警列表*/




//中联Lorawan读卡器
export const getZlLorawanCardList = () => urlPk + "parking/lorawanCard/page";
export const upDateOneZlLorawanCard = () => urlPk + "parking/lorawanCard";

export const getZlLorawanUnbindReadcard = () => urlPk + "parking/lorawanCard/usableLorawanCard";
export const bindZlLorawanReadcard = () => urlPk + "parking/lorawanCard/blindLorawanCard";
//中联Lorawan地磁
export const getZlLorawanOnerankdevList = () => urlPk + "parking/lorawanOnerankdev/page";
export const upDateOneZlLorawanOnerankdev = () => urlPk + "parking/lorawanOnerankdev";

export const getZlLorawanUnbindOnerankdev = () => urlPk + "parking/lorawanOnerankdev/usableLorawanOnerankdev";
export const bindZlLorawanOnerankdev = () => urlPk + "parking/lorawanOnerankdev/blindLorawanOnerankdev";

//中联nb读卡器
export const getZlNbCardList = () => urlPk + "parking/nbCard/page";
export const upDateOneZlNbCard = () => urlPk + "parking/nbCard";


export const getZlNbUnbindReadcard = () => urlPk + "parking/nbCard/usableNbCard";
export const bindZlNbReadcard = () => urlPk + "parking/nbCard/blindNbCard";

//中联nb地磁
export const getZlNbOnerankdevList = () => urlPk + "parking/nbOnerankdev/page";
export const upDateOneZlNbOnerankdev = () => urlPk + "parking/nbOnerankdev";

export const getZlNbUnbindOnerankdev = () => urlPk + "parking/nbOnerankdev/usableNbOnerankdev";
export const bindZlNbOnerankdev = () => urlPk + "parking/nbOnerankdev/blindNbOnerankdev";


//财务管理
export const getFinancialList = () => urlPk + "parking/parkingOrders/queryOrderIncome";
//数据分析
export const analyse = () => urlPk + "parking/analyseOrder/analyseByPayType";
// export const statistics = () => urlPk + "parking/analyseOrder/analyseAll";

// export const chargeChartList = () => urlPk + "parking/analyseCharge/queryAnalyseCharge";
export const chargeTableList = () => urlPk + "parking/analyseCharge/page";
export const chargeRanking = () => urlPk + "parking/parkingOrders/chargeRanking";

/**
 * data:2019.10.10
 *
 */
//export const getAllChargeUsers= () => urlPk + 'parking/chargeUser/all';
export const getAllChargeUsers = () => urlPk + 'parking/chargeUser/page';
/**
 * data:2019.10.10
 * 
 */


// 巡检员日报表，月报表
export const getChargeUserMonthyMoney = () => urlPk + 'parking/chargeUser/queryChargeUserMoneyByDate';
// 巡检员日报表，月报表费用按天统计
// export const getChargeUserMonthyMoneyByDay= () => urlPk + 'parking/chargeUser/DailyChargeRecord';
/**
 * data:2019.03.18
 * 内容：按泊位段统计收费
 */
export const getAnalyseChargeByArea = () => urlPk + 'parking/parkingArea/queryAnalyseCharge';
/**
 * data:2019.0319
 * 内容：按停车道路统计收费
 */
export const getAnalyseChargeByParking = () => urlPk + 'parking/parking/queryAnalyseCharge';

//员工管理

//作用域管理
export const getScopeList = () => urlPk + "parking/actionScope/queryActionScopeByEnabled";
export const getScopeParkList = () => urlPk + "parking/actionScope/getActionScopeCheckById";
export const addScope = () => urlPk + "parking/actionScope";
//export const oneScope = () => urlPk + "parking/actionScope/one";
export const scopeEmpower = () => urlPk + "parking/actionScopeContent/empower";

//角色管理
/**
 * author:mao
 * date:2019.09.20
 */
// export const getGroupList = () => urlPk + "admin/group/user/queryCreateGroupByCurrent";
// export const getGroupAuthorList = () => urlPk + "admin/group/menu/authorize/list";
// //export const getGroupAuthorCheckedList= () => urlPk + "admin/group/258651cfd4ca41cbaa70d1b233659b5c/authority/menu";
// export const addGroup = () => urlPk + "admin/group";
// //export const scopeEmpower = () => urlPk + "parking/actionScopeContent/actionScopeEmpower";
// export const getOneMenuButtons = () => urlPk + "admin/group/element/authorize/list/check";

// export const getGroupList = () => urlPk + "admin/group/user/queryCreateGroupByCurrent";
export const getGroupList = () => urlPk + "admin/group/tree";
/**author:mao date:2019.09.26 content:添加作用域树 */
export const getScopeTree = () => urlPk + "parking/baseDept/bindingTree";
/**author:mao date:2019.09.26 content:添加作用域树 */
export const getGroupAuthorList = () => urlPk + "admin/group/menu/authorize/list";
export const getGroupCheckedList = () => urlPk + "admin/group/authority/menu";
// export const getGroupAuthorCheckedList= () => urlPk + "admin/group/258651cfd4ca41cbaa70d1b233659b5c/authority/menu";
export const addGroup = () => urlPk + "admin/group";
//export const scopeEmpower = () => urlPk + "parking/actionScopeContent/actionScopeEmpower";
//export const getOneMenuButtons = () => urlPk + "admin/group/element/authorize/list/check";
export const queryButtonList = () => urlPk + "admin/group/element/authorize/list";
/**
 * author:mao
 * date:2019.09.20
 */

//用户管理
/**
 * author:mao
 * date:2019.09.20
 */
// export const addUser = () => urlPk + "parking/user/";
// export const getUserList = () => urlPk + "parking/user/queryUser";
// export const getManagerSingle = () => urlPk + 'admin/user/one';
// export const getUserSingleScope = () => urlPk + 'parking/actionScope/getActionScopeByUserId';
// export const getUserSingleGroup = () => urlPk + 'admin/group/user/queryGroupByUserId';
// export const resetPassword = () => urlPk + 'admin/user/resetPassword';

// export const addUser = () => urlPk + "parking/user/";
export const addUser = () => urlPk + "admin/user/reateUser";
export const editUser = () => urlPk + "admin/user/usermod";
// export const delRole = () => urlPk + 'admin/user';
export const delAccount = () => urlPk + "admin/user/removeUser";
// export const getUserList = () => urlPk + "parking/user/queryUser";
export const getUserList = () => urlPk + "admin/user/queryUser";
export const getManagerSingle = () => urlPk + 'admin/user/one';
export const getUserSingleScope = () => urlPk + 'parking/actionScope/getActionScopeByUserId';
export const getUserSingleGroup = () => urlPk + 'admin/group/user/queryGroupByUserId';
export const resetPassword = () => urlPk + 'admin/user/resetPassword';
export const getDepartNotBind = () => urlPk + 'parking/baseDepart/notBound';
/**
 * author:mao
 * date:2019.09.20
 */

//登录用户
export const getOneUser = () => urlPk + 'admin/user/info';
// export const changePassword = () => urlPk + 'admin/user/changePasswordNew';
export const changePassword = () => urlPk + 'admin/user/changePassword';


//巡检员管理

// export const chargeUserList = () => urlPk + 'parking/chargeUser/page';

export const chargeUserList = () => urlPk + 'parking/chargeUser/queryChargeUserByIdOrNameOrTime';

// export const addChargeUser= () => urlPk + 'parking/chargeUser/saveUser';

// export const editChargeUser= () => urlPk + 'parking/chargeUser/updateUser';

export const addOrEditChargeUser = () => urlPk + 'parking/chargeUser/saveUser';

export const oneChargeUser = () => urlPk + 'parking/chargeUser/queryChargeUserByid';

// export const oneChargeUser= () => urlPk + 'parking/chargeUser';

export const removeChargeUser = () => urlPk + 'parking/chargeUser/removeUser';

export const resetChargeUserPassword = () => urlPk + 'parking/chargeUser/resetPassword';

// export const getUnbindArea= () => urlPk + 'parking/chargeUser/queryNoBindArea';

// export const chargeUserAll= () => urlPk + 'parking/chargeUser/queryAllChargeUser';



//车辆管理
// export const getWhiteList= () => urlPk + 'parking/plateFree/getPlateFreeInfo';
export const getWhiteList = () => urlPk + 'parking/plateFree/page';

export const oneWhite = () => urlPk + 'parking/plateFree';

export const updateOneWhite = () => urlPk + 'parking/plateFree/updatePlateFree';

//月租车
export const getMonthlyCar = () => urlPk + 'parking/PlateMonthlyRecord/getUserMonthlyCarToplatform';

// export const getMonthlyChargeRule= () => urlPk + 'parking/monthlycarRulesByParking/getParkingMonthlyChargeRule';
export const getMonthlyChargeRule = () => urlPk + 'parking/rentMonthCharge/page';
export const getOneMonthlyChargeRule = () => urlPk + 'parking/rentMonthCharge';
export const addOrEditMonthlyChargeRule = () => urlPk + 'parking/monthlycarRulesByParking';

//根据物业Id查询车场
export const getParkingsByProperty = () => urlPk + 'parking/parking/queryParking';

//岗位欠费率报表
export const getArrearsRateReportByPost=()=>urlPk + 'parking/parkingOrders/ratePostRiseReport';



//腾讯临时

//设备管理
// export const nbList= () => urlPk + 'parking/nb/page';
export const pdaList = () => urlPk + 'parking/pda/page';
export const updateOnePda = () => urlPk + 'parking/pda';
export const pilesList = () => urlPk + 'parking/piles/page';
export const signoList = () => urlPk + 'parking/signo/page';
export const videoPileList = () => urlPk + 'parking/videoPile/page';
export const liuliankaList = () => urlPk + 'parking/liuliangka/page';
export const liticheList = () => urlPk + 'parking/litiche/page';
export const xichejiList = () => urlPk + 'parking/xicheji/page';
export const workOrderList = () => urlPk + 'parking/workOrder/page';
export const iotHubList = () => urlPk + 'parking/iotHub/page';
/**
 * 2019.09.16
 */
export const nbList = () => urlPk + 'parking/nbOnerankdev/page';
export const editNb = () => urlPk + 'parking/nbOnerankdev';
export const unbindNbDev = () => urlPk + 'parking/nbOnerankdev/usableNbOnerankdev';
export const bindNbDev = () => urlPk + 'parking/nbOnerankdev/blindNbOnerankdev';
export const blindHighVideo=()=>urlPk + 'parking/nbOnerankdev/blindHighVideo';

/**
 * 2019.10.07
 */
export const equipTree = () => urlPk + 'parking/alarmMonitoring/queryAllByEnabled';
/**
 * 2019.10.07
 */

//车主
export const messagePushList = () => urlPk + 'parking/messagePush/page';
export const complainList = () => urlPk + 'parking/complain/page';
export const complainReply = () => urlPk + 'parking/complain/reply';

//巡检员
export const ipqcList = () => urlPk + 'parking/ipqc/page';
export const feedbackList = () => urlPk + 'parking/ipqcMessageFeedback/page';
// export const schedulingList= () => urlPk + 'parking/scheduling/page';
export const schedulingList = () => urlPk + 'parking/pdaLoginLog/page';
export const attendanceList = () => urlPk + 'parking/pdaAttendance/page';
export const departmentList = () => urlPk + 'parking/department/page';
//巡检员收费概览
export const getChargeStatistics = () => urlPk + 'parking/parkingOrders/chargeStatistics';
//巡检员欠费统计
export const getArrearsStatistics = () => urlPk + 'parking/parkingOrders/arrearsStatistics';

//收费管理
export const payEList = () => urlPk + 'parking/payE/page';
export const billList = () => urlPk + 'parking/iotHub/page';
export const chargingRulesList = () => urlPk + 'parking/chargingRules/page';
export const discountsList = () => urlPk + 'parking/discounts/page';
export const recoveredList = () => urlPk + 'parking/recovered/page';
export const invoiceList = () => urlPk + 'parking/invoice/page';
//车辆管理
export const arrearageList = () => urlPk + 'parking/arrearage/page';

//报表管理
// export const  getParkingDayReportList= () => urlPk + 'parking/dailystatement/page';
export const getParkingDayReportList = () => urlPk + 'parking/parkingOrders/dailyStatement';
// export const  getParkingMonthReportList= () => urlPk + 'parking/monthlystatement/page';
export const getParkingMonthReportList = () => urlPk + 'parking/parkingOrders/monthlyStatement';
export const getGroupDayReportList = () => urlPk + 'parking/parkingOrders/groupDailyStatement';
export const getGroupMonthReportList = () => urlPk + 'parking/parkingOrders/groupMonthlyStatement';
export const getChargeAreaStatisticsList = () => urlPk + 'parking/parkingOrders/chargeUserStatistics';
export const getChargeUserStatisticsList = () => urlPk + 'parking/parkingOrders/chargeStatisticsInspectors';
export const getAllAreaByParkingId = () => urlPk + 'parking/parkingArea/queryAreaByParkingId';
export const getUserStatistics = () => urlPk + 'parking/parkingOrders/userStatistics';
export const getArrearsDayReportList=()=>urlPk + 'parking/parkingOrders/recoveryArrearsReport';
export const getArrearsRateReportList=()=>urlPk + 'parking/parkingOrders/rateRiseReport';

//报表管理 图表
export const getParkingDayList = () => urlPk + 'parking/parkingOrders/dailyChart';
export const getParkingMonthList = () => urlPk + 'parking/parkingOrders/monthlyChart';
export const getGroupDayList = () => urlPk + 'parking/parkingOrders/groupDailyChart';
export const getGroupMonthList = () => urlPk + 'parking/parkingOrders/groupMonthlyChart';

//数据分析
export const deviceAnalyzeList = () => urlPk + 'parking/deviceAnalyze/page';
export const areaMapList = () => urlPk + 'parking/areaMap/page';
// export const  spaceAnalyzeList= () => urlPk + 'parking/spaceAnalyze/page';
export const spaceAnalyzeList = () => urlPk + 'parking/spaceAnalysis/list';
export const equipmentList = () => urlPk + 'parking/nbOnerankdev/devAnalysis';

//诱导中心
export const vmsDeviceList = () => urlPk + 'parking/vmsDevice/page';
export const vmsDispatchList = () => urlPk + 'parking/vmsDispatch/page';
export const vmsMessageList = () => urlPk + 'parking/vmsMessage/page';

//商户管理
export const alarmList = () => urlPk + 'parking/alarm/page';
/**author:mao date:2019.09.26 content:修改集团查询接口 */
// export const  propertyList= () => urlPk + 'parking/property/page';
// export const  groupList= () => urlPk + 'parking/group/page';
export const groupList = () => urlPk + 'parking/baseDept/page';
export const oneGroup = () => urlPk + 'parking/baseDept/one';
export const updateOneGroup = () => urlPk + 'parking/baseDept';
export const deleteOneGroup = () => urlPk + 'parking/baseDept';
// 集团管理删除
export const deleteGroup = () => urlPk + 'parking/baseDept/removeProperty';

/**author:mao date:2019.09.26 content:新增接口 */

//日志
export const abnormalLogList = () => urlPk + 'parking/abnormalLog/page';

//数据分析
export const statistics = () => urlPk + "parking/parkingOrders/statistics";
export const chargeChartList = () => urlPk + "parking/parkingOrders/income";

//月租车
// 都匀分支使用路径
export const monthlyUserAddOrEdit = () => urlPk + "parking/rentMonthUser/renewal";
export const monthlyUserOne = () => urlPk + "parking/rentMonthUser";

export const monthlyUserList = () => urlPk + "parking/rentMonthUser/page";
export const allMonthlyChargeRule = () => urlPk + "parking/rentMonthCharge/query";
export const rentMonthUserIntervals = () => urlPk + "parking/rentMonthUser/queryIntervals";
// 发行月年租卡，车主在小程序办理月租卡
// export const monthlyUserOne = () => urlPk + "parking/rentMonthUserCharge";
// export const monthlyUserList = () => urlPk + "parking/rentMonthUserCharge/page";

//获取更新token
export const refreshToken = () => urlPk + "auth/jwt/refresh";

//室内停车场
//停车场类型字典
export const getParkingType = () => urlPk + 'dict/dictValue/type/parking_type';
//车辆管理
export const getParkingWhiteList = () => urlPk + 'parking/plateFree/getPlateFreeInfo';
export const oneParkingWhite = () => urlPk + 'parking/plateFree';
export const updateOneParkingWhite = () => urlPk + 'parking/plateFree/updatePlateFree';

//室内停车场
//进出记录
export const indoorAllParkings = () => urlPk + 'onsite/park/page';

export const indoorIoRecordList = () => urlPk + 'onsite/parkingRecord/page';

export const indoorAllCarType = () => urlPk + 'dict/dictValue/type/car_type';

export const indoorAllPlateType = () => urlPk + 'dict/dictValue/type/plate_type';

export const indoorAllOpenMethod = () => urlPk + 'dict/dictValue/type/open_method';

export const indoorAllPlateColor = () => urlPk + 'dict/dictValue/type/plate_color';

//财务
// export const  indoorAllAnalyse= () => urlPk + 'onsite/parkingRecord/analyseAll';
export const indoorAllAnalyse = () => urlPk + 'onsite/onsiteOrders/home';
export const chargeOfDay = () => urlPk + 'onsite/parkingRecord/queryParkingrecord';
export const chargeOfMonth = () => urlPk + 'onsite/parkingRecord/queryTotalIncome';

//数据分析
export const indoorIncomeAnalysis = () => urlPk + 'onsite/parkingRecord/queryPayment';
export const indoorIOTypeAnalysis = () => urlPk + 'onsite/parkingRecord/queryProcessType';
export const indoorPassTypeAnalysis = () => urlPk + 'onsite/parkingRecord/queryOutType';
export const indoorPayChannelAnalysis = () => urlPk + 'onsite/parkingRecord/analyseByPay';

//支付配置
//新疆银联无感
export const xinjiangUnionPayNosenseConfigureOne = () => urlPk + 'onsite/sikUnionpayUnconscious/one';
export const xinjiangUnionPayNosenseConfigureAddOrEdit = () => urlPk + 'onsite/sikUnionpayUnconscious';
//新疆银联主扫
export const xinjiangUnionPayUnionConfigureOne = () => urlPk + 'onsite/sikUnionpayQrcodePay/one';
export const xinjiangUnionPayUnionConfigureAddOrEdit = () => urlPk + 'onsite/sikUnionpayQrcodePay';
// export const  xinjiangUnionPayUnionConfigureUpload= () => urlPk + 'onsite/sikUnionpayQrcodePay/upload';

//微信
export const weixinPayConfigureOne = () => urlPk + 'parking/wechatJsapi/one';
export const weixinPayConfigureAddOrEdit = () => urlPk + 'parking/wechatJsapi';
//支付宝
export const aliPayConfigureOne = () => urlPk + 'parking/alipayWap/one';
export const aliPayConfigureAddOrEdit = () => urlPk + 'parking/alipayWap';


/**
 * 2019-09-05修改
 */
export const ccbUnionConfigureOne = () => urlPk + 'onsite/ccbPay/one';
export const ccbUnionConfigureAddOrEdit = () => urlPk + 'onsite/ccbPay';


//宁夏医院银联主扫
export const ningxiaUnionPayUnionConfigureOne = () => urlPk + 'onsite/unionpayAtoQrcodePay/one';
export const ningxiaUnionPayUnionConfigureAddOrEdit = () => urlPk + 'onsite/unionpayAtoQrcodePay';

//中行
export const bocConfigureOne = () => urlPk + 'onsite/bocPay/one';
export const bocConfigureAddOrEdit = () => urlPk + 'onsite/bocPay';

//农行
export const abcConfigureOne = () => urlPk + 'onsite/abcPay/one';
export const abcConfigureAddOrEdit = () => urlPk + 'onsite/abcPay';

//电子发票配置
// export const  invoiceConfigureOne= () => urlPk + 'parking/electronicInvoiceConfig/one';
// export const  invoiceConfigureAddOrEdit= () => urlPk + 'parking/electronicInvoiceConfig';

//电子发票配置
export const invoiceConfigureOne = () => urlPk + 'onsite/electronicInvoiceConfig/one'; //查询电子发票配置
export const invoiceConfigure = () => urlPk + 'onsite/electronicInvoice/findByPage'; //查询电子发票记录
export const invoiceConfigureAddOrEdit = () => urlPk + 'onsite/electronicInvoiceConfig'; //新增电子发票配置
export const invoiceConfigureAddOr = () => urlPk + 'onsite/electronicInvoiceConfig/id'; //修改电子发票配置
export const invoiceConfigureAddOrEditTrue = () => urlPk + '/onsite/electronicInvoice/invoicing'; //电子发票开具


//车场管理

//车场管理id
// export const  getParkList= () => urlPk + 'onsite/park/page';
export const getParkList = () => urlPk + 'onsite/baseDepart/page';
export const parkingParkAdd = () => urlPk + 'onsite/park';
export const getparkingParkSingle = () => urlPk + 'onsite/park/one';
export const getAllCities = () => urlPk + 'onsite/citys/page';

export const getAllParkings = () => urlPk + 'onsite/park/allParking';

export const getArealist = () => urlPk + 'onsite/parkingArea/page';
export const getBoxlist = () => urlPk + 'onsite/parkingSentryBox/page';
export const getChannellist = () => urlPk + 'onsite/parkingChannel/page';



export const getAllByParking = () => urlPk + 'onsite/baseArea/trees';
export const addOrEditParking = () => urlPk + 'onsite/baseArea';

//集团管理

// export const  addOrEdit= () => urlPk + 'parking/baseDepart';
export const addOrEdit = () => urlPk + 'parking/parking';
export const queryPark = () => urlPk + 'onsite/baseDepart/page';
export const queryOnePark = () => urlPk + 'onsite/baseDepart/one';

export const getAllPayType = () => urlPk + 'dict/dictValue/type/payment_channel';
export const getPayConfigure = () => urlPk + 'onsite/payController/payIfExist';

//获取集团已有的配置信息
export const getOneGroupConfigure = () => urlPk + 'parking/baseDept/baseConfig';
//配置集团配置信息
export const requestConfigureOneGroupConfigure = () => urlPk + 'parking/baseDept/baseConfig';
//获取车场已有的配置信息
export const getOneParkingConfigure = () => urlPk + 'onsite/parkingConfig/find';
//配置车场配置信息
export const requestConfigureOneParkingConfigure = () => urlPk + 'onsite/parkingConfig/add';
/**
 * 
 * date:2019.10.09
 */
export const getGenerateActivationCode = () => urlPk + 'onsite/activationCode';
export const getActivationCodeList = () => urlPk + 'onsite/activationCode/page';
/**
 * 
 * date:2019.10.09
 */


/**
 * Author:mao
 * date:2019.09.18
 */
export const getRelatedDepart = () => urlPk + 'onsite/baseDepart/queryParentId';
export const removeDepart = () => urlPk + 'onsite/baseDepart/remove';
/**
 * Author:mao
 * date:2019.09.18
 */


//报表信息
export const fastenCarPayRecordAPI = () => urlPk + 'onsite/monthlycarOrder/page';
export const interimCarPayRecordAPI = () => urlPk + 'onsite/onsiteOrders/page';
export const discountRecordAPI = () => urlPk + 'onsite/discountsMsg/page';
export const shopRechargeRecordAPI = () => urlPk + 'onsite/shopsRechargeOrder/page';


//统计分析
export const getParkingParkingDayReportList = () => urlPk + 'onsite/onsiteOrders/dailyStatement';
export const getParkingParkingMonthReportList = () => urlPk + 'onsite/onsiteOrders/monthlyStatement';
export const getParkingGroupDayReportList = () => urlPk + 'onsite/onsiteOrders/groupDailyStatement';
export const getParkingGroupMonthReportList = () => urlPk + 'onsite/onsiteOrders/groupMonthlyStatement';
//车主管理
export const getCarOwnerList = () => urlPk + 'onsite/userMoncards/page';

//消费打折
//商户
export const getPosList = () => urlPk + 'onsite/shopsUser/page';
export const addShopUser = () => urlPk + 'onsite/shopsUser';
export const editShopUser = () => urlPk + 'onsite/shopsUser/update';
export const userRecharge = () => urlPk + 'onsite/shopsUser/recharge';
// 重置密码
export const resetPasswordV = () => urlPk + 'onsite/shopsUser/update';


export const getOneShopUser = () => urlPk + 'onsite/shopsUser/one';
// export const  getPosList= () => urlPk + 'onsite/shopsUser/page';
// export const  getPosList= () => urlPk + 'onsite/shopsUser/page';

//优免规则
export const getDiscountRulesByUserShop = () => urlPk + 'onsite/discountsRule/page';
export const requestAllDiscountRules = () => urlPk + 'dict/dictValue/type/discounts_type';
export const operateDiscountRules = () => urlPk + 'onsite/discountsRule';
//优免二维码
export const addDiscountQrCode = () => urlPk + 'onsite/discountsQrcode';
// export const  editDiscountQrCode= () => urlPk + 'onsite/discountsRule';
// export const  getDiscountRuleByShop= () => urlPk + 'onsite/discountsRule/all';
export const getOneQrCode = () => urlPk + 'onsite/discountsQrcode/one';
export const getQrCodeList = () => urlPk + 'onsite/discountsQrcode/page';


export const getOnsiteParkingDayReportList = () => urlPk + 'onsite/onsiteOrders/dailyStatement';
// export const  getParkingMonthReportList= () => urlPk + 'parking/monthlystatement/page';
export const getOnsiteParkingMonthReportList = () => urlPk + 'onsite/onsiteOrders/monthlyStatement';
export const getOnsiteGroupDayReportList = () => urlPk + 'onsite/onsiteOrders/groupDailyStatement';
export const getOnsiteGroupMonthReportList = () => urlPk + 'onsite/onsiteOrders/groupMonthlyStatement';


//字典
//优免类型
export const requestAllDiscountType = () => urlPk + 'dict/dictValue/type/discounts_type';
//支付字典
export const requestAllPayType = () => urlPk + 'dict/dictValue/type/onsite_pay_type';
//打折状态
export const requestAllDiscountsStatus = () => urlPk + 'dict/dictValue/type/discountsStatus';
//收费规则类型
export const requestAllChargeRuleType = () => urlPk + 'dict/dictValue/type/charge_rule_type';

//手持机更新的类型
export const requestAllUpdateType = () => urlPk + 'dict/dictValue/type/app_company';

//集团配置项
export const requestGroupBaseConfig = () => urlPk + 'dict/dictValue/type/base_config';

//车场配置项
export const requestParkingBaseConfig = () => urlPk + 'dict/dictValue/type/parking_base_config';
//电子发票服务商
export const requestInvoicingServer = () => urlPk + 'dict/dictValue/type/invocing_server';
//出场方式字典
export const requestOpenmethodType = () => urlPk + 'dict/dictValue/type/open_method'
//nb地磁类型
export const requestNbType = () => urlPk + 'dict/dictValue/type/company'

//根据集团Id获取收费员列表
export const requestChargeUserByGroupId = () => urlPk + 'parking/chargeUser/queryChargeUser';

//批量删除车位
export const batchDelSpaces = () => urlPk + 'parking/parkingSpace/batchDelete';

//批量删除Nb地磁
export const batchDelNbGeomagnetism = () => urlPk + 'parking/nbOnerankdev/batchDelete';



//高位视频
//停车区域列表
export const requestAreaParkingList = () => urlPk + 'parking/intellidataParkingArea/page';
//操作单个停车区域
export const requestOneAreaParking = () => urlPk + 'parking/intellidataParkingArea';
//校准停车区域
export const requestCorrectParkArea = () => urlPk + 'parking/intellidataParkingArea/correctParkArea';
//获取所有停车区域
export const requestAllAreaParking = () => urlPk + 'parking/intellidataParkingArea/all';
//高位视频列表
export const requestIntellidataDeviceList = () => urlPk + 'parking/intellidataDevice/page';
//操作单个高位视频
export const requestOneIntellidataDevice = () => urlPk + 'parking/intellidataDevice';
//校准单个高位视频
export const requestCorrectIntellidataDevice = () => urlPk + 'parking/intellidataDevice/correctDevice';
//进出记录
export const requestIntellidataDeviceIORecord = () => urlPk + 'parking/record/page';
//路牙进出记录
export const requestDentalMachineRecord= () => urlPk + 'parking/dentalMachineRecord/page';

//homeData
export const homeDatas = () => urlPk + 'parking/parkingOrders/home';
export const homeParkingDatas = () => urlPk + 'parking/parkingOrders/sketch';
export const homeMoneyDatas = () => urlPk + 'parking/parkingOrders/paySketch';
export const mapPark = () => urlPk + 'parking/parkingOrders/parkingAddress';

//手持机自动更新
export const appVersion = () => urlPk + 'parking/appVersion';
export const appVersionList = () => urlPk + 'parking/appVersion/page';


//电子发票
export const getInvoiceRedPunch = () => urlPk + 'onsite/electronicInvoice/redPunch'; //发票冲红
export const getInvoiceReInvoicing = () => urlPk + 'onsite/electronicInvoice/reInvoicing'; //发票重开


//会员管理/充值记录
export const getRechargeOrderList = () => urlPk + 'parking/rechargeOrder/page';

import iconImg from '../assets/images/mark.png'
console.log("iconImg=>", iconImg)


// 小程序广告管理
export const editOneAdvertisement = () => urlPk + 'parking/advertisement';
export const fetchAdvertisementPage = () => urlPk + 'parking/advertisement/page';

//余额消费记录
export const fetchBalancePayRecordPage = () => urlPk + 'parking/billDetail/bill';

//路边订单管理上传照片
export const uploadParkingOrdersPhoto=()=>urlPk+'parking/parkingOrders/uploadPics';

//all 停车场
export const fetchParkigList=()=>urlPk+'parking/parking/queryParking';

//area by parkingId

export const fetchAreaList=()=>urlPk+'parking/parkingArea/queryAreaByParkingId';

//用户充值

export const resRecharge=()=>urlPk+'parking/appUser/recharge';

//泊位分析列表
export const fetchSpaceOrderAnalysisList=()=>urlPk+'parking/spaceOrderAnalysis/list';

//车牌列表
export const fetchPlateList=()=>urlPk+'parking/appUser/userPlate';

//解绑车牌
export const reqUnbindPlate=()=>urlPk+'parking/appUser/unbindPlate';

//车主管理消除金额
export const reqReduceMoney =()=>urlPk+'parking/appUser/reduce';

// all 物业
export const fetchPropertyList=()=>urlPk+"parking/baseDept/property";

//all 集团
export const fetchGroupList=()=>urlPk+"parking/baseDept/group";

//车主管理 金额统计
export const reqUserTotalAmount=()=>urlPk+"parking/appUser/totalAmount";

//充值活动
export const fetchRechargeConfigurationPage=()=>urlPk+"parking/activity/page";

//添加或修改充值活动
export const updateOneRechargeConfiguration=()=>urlPk+"parking/activity";

// 获取收费员历史轨迹
export const getHistoryLocation = id => urlPk.concat('parking/chargeUser/historyLocation?id=').concat(id);

// 获取充值记录统计
export const getTotalAmount = () => urlPk.concat('parking/rechargeOrder/totalAmount');

// 获取账单明细
export const getBillTotalAmount = () =>  urlPk.concat('parking/billDetail/totalAmount');

export const getRentMonthOrderparking = () => urlPk.concat('parking/rentMonthOrder/page');

//月年租卡
export const rentMonthPage=()=>urlPk.concat(`parking/rentMonthCharge/extpage`)
//月年租卡发行
export const rentMonthRelease=()=>urlPk.concat(`parking/rentMonthCharge/release`)
//月年租卡下线
export const rentMonthDownline=()=>urlPk.concat(`parking/rentMonthCharge/offline`)

//未下单数据分析
export const getNoOrderList = () => urlPk.concat('parking/noOrder/overtimeOrdering');

//收入排名
export const getIncomeRank=()=>urlPk.concat('parking/parkingOrders/collectorRanking');

//30天收入统计
export const getIncomeTrend=()=>urlPk.concat('parking/parkingOrders/revenueTrends');

//车场远程开闸
export const getRemoteOpen=()=>urlPk.concat('onsite/payController/remoteOpening');

//巡逻车列表
export const patrolCarList=()=>urlPk.concat('parking/patrolAircraft/page');

//update巡逻车
export const onePpatrolCar=()=>urlPk.concat('parking/patrolAircraft');

//欠费追缴规则列表
export const getRuleConfigurationList=()=>urlPk.concat('parking/pushRules/page');

//更新欠费追缴规则
export const updateOneRuleConfiguration=()=>urlPk.concat('parking/pushRules');

//都匀欠费列表
export const getArrearsList=()=>urlPk.concat('parking/parkingOrders/queryUnpayOrder');
//都匀验证黔通卡
export const reqVerifyEtc=()=>urlPk.concat('parking/parkingOrders/verifyETC');
//都匀ETC追缴
export const reqEtcPay=()=>urlPk.concat('parking/parkingOrders/etcPayOrder');

//车位
export const shareSpaceList=()=>urlPk.concat('onsite/share/page');

//车位详情
export const shareSpaceDetail=()=>urlPk.concat('onsite/share/audit');

//车位审核
export const shareSpaceAudit=()=>urlPk.concat('onsite/share/audit');

//预约记录
export const reservationRecord=()=>urlPk.concat('onsite/share/book/page');

// 预约记录对应的所有预约订单
export const shareRecordAllOrders=(bookId)=>urlPk.concat(`onsite/share/book/orders/${bookId}`)

//共享停车场
export const shareParks=()=>urlPk.concat('onsite/share/getParkings');

//根据共享车场查区域
export const areasByShareParkingId=()=>urlPk.concat('onsite/share/getParkingAreas');

//根据车场Id查询网关
export const gatewaysByParkingId=()=>urlPk.concat('onsite/gateway/parkGatewayVos');

//网关列表
export const gateways=()=>urlPk.concat('onsite/gateway/parkGatewayVos');
//网关详情
export const gatewayDetail=()=>urlPk.concat('onsite/gateway/getGateInfo');
//新增网关
export const addGateway=()=>urlPk.concat('onsite/gateway/save');
//修改网关
export const updateGateway=()=>urlPk.concat('/onsite/gateway/update');
//删除网关
export const deleteGateway=()=>urlPk.concat('onsite/gateway/delete');
//网关重启
export const resetGateway=()=>urlPk.concat('onsite/gateway/restart');
//NB4G锁分页列表
export const nb4gLockPage=()=>urlPk.concat('parking/nb4gLock/page');
//NB4G锁新增
export const nb4gLockAdd=()=>urlPk.concat('parking/nb4gLock');
//NB4G锁修改
export const nb4gLockUpdate=(id)=>urlPk.concat(`parking/nb4gLock/${id}`);
//NB4G锁删除
export const nb4gLockDelete=(id)=>urlPk.concat(`parking/nb4gLock/${id}`);
//NB4G锁升锁(POST, 参数 lockCode 多个逗号分隔)
export const nb4gLockOpen=()=>urlPk.concat('parking/nb4gLock/open');
//NB4G锁降锁(POST, 参数 lockCode 多个逗号分隔)
export const nb4gLockClose=()=>urlPk.concat('parking/nb4gLock/close');
//NB4G锁复位(POST, 参数 lockCode 多个逗号分隔)
export const nb4gLockReset=()=>urlPk.concat('parking/nb4gLock/reset');
//NB4G锁重启(POST, 参数 lockCode 多个逗号分隔)
export const nb4gLockRestart=()=>urlPk.concat('parking/nb4gLock/restart');
//地锁列表
export const locks=()=>urlPk.concat('onsite/lock/locks');
//地锁详情
export const lockDetail=()=>urlPk.concat('onsite/lock/getOne');
//新增地锁
export const addLock=()=>urlPk.concat('onsite/lock/save');
//修改地锁
export const updateLock=()=>urlPk.concat('onsite/lock/edit');
//删除地锁
export const deleteLock=()=>urlPk.concat('onsite/lock/delete');
//升锁
//export const upLock=()=>urlPk.concat('onsite/lock/open');
export const upLock=()=>urlPk.concat('onsite/lock/open');
//降锁
//export const downLock=()=>urlPk.concat('onsite/lock/close');
export const downLock=()=>urlPk.concat('onsite/lock/close');
//重启
//export const resetLock=()=>urlPk.concat('onsite/lock/restart');
export const resetLock=()=>urlPk.concat('onsite/lock/reset');

//共享停车收费规则新增
export const addShareSpaceChargeRule=()=>urlPk.concat('onsite/parkingCharges/add');


//共享停车收费规则修改
export const editShareSpaceChargeRule=()=>urlPk.concat('onsite/parkingCharges/update');

//共享停车收费规则删除
export const delShareSpaceChargeRule=()=>urlPk.concat('onsite/parkingCharges/delete');

//查询单条收费规则
export const shareChargeRuleOne=()=>urlPk.concat('onsite/parkingCharges/get');

//收费规则列表
export const shareChargeRuleList=()=>urlPk.concat('onsite/parkingCharges/lists');

//收费规则测试
export const testChargeRule=()=>urlPk.concat('onsite/parkingCharges/testCharge');

//共享停车根据车场查网关
export const gatesByParkingId=()=>urlPk.concat('onsite/gateway/parkGatewayVos');

//共享停车根据网关查车位锁
export const locksByGateId=()=>urlPk.concat('onsite/lock/locksByGates');

//共享停车绑定/解绑车锁
export const bindLock=()=>urlPk.concat('onsite/share/bindLock');
//删除车位
export const delShareSpace=()=>urlPk.concat('onsite/share/delete');
//[分账]级联共享车场车位
export const shareParkCascade=()=>urlPk.concat('onsite/share/parkingOps');

//[分账]更新分账配置
export const updateShareProfitConfig=()=>urlPk.concat('onsite/share/profit/config');

//[分账]获取用户信息
export const shareUserInfo=()=>urlPk.concat('onsite/share/profit/config/ops');

//[分账]获取分账配置
export const profitConfigList=()=>urlPk.concat('onsite/share/profit/config/list');

//[分账]提现配置
export const   withdrawRule=()=>urlPk.concat('onsite/share/profit/withdraw/rule'); 

//[分账]更新分账规则状态
export const  updateWithdrawRuleStatus=()=> urlPk.concat('onsite/share/profit/withdraw/rule/updateStatus');

//[分账]更新分账配置状态
export const updateConfigStatus=()=>urlPk.concat('onsite/share/profit/config/updateStatus')

//[分账]提现配置审批用户
export const groupUserOps=()=> urlPk.concat('admin/user/groupUserOps')

//[分账]操作验证码
export const sendWithdrawCode=()=> urlPk.concat('onsite/share/profit/withdraw/rule/sms')

//[分账]提现用户
export const   withdrawUser=()=>urlPk.concat('onsite/share/profit/withdraw/rule/bind'); 

//[分账]提现用户
export const   withdrawRuleOps=()=>urlPk.concat('onsite/share/profit/withdraw/rule/ops'); 

//[分账]收益
export const   profitInfos=()=>urlPk.concat('onsite/share/profit/getProfitInfos'); 


//[分账]收益汇总   
export const   profitRevenueSummary=()=>urlPk.concat('onsite/share/profit/revenueSummary'); 

//[分账]提现记录  
export const   withdrawApplication=()=>urlPk.concat('onsite/share/profit/withdraw/application'); 

//[分账]提现申请审核
export const   withdrawApplicationAudit=()=>urlPk.concat('onsite/share/profit/withdraw/application');

//[分账]根据提现申请获取提现规则
export const   withdrawRuleByApplication=(applicationId)=>urlPk.concat('onsite/share/profit/withdraw/rule/application/' + applicationId); 

//[分账]分账记录
export const   splitBillRecord=()=>urlPk.concat('onsite/share/profit/record');

// 根据预约记录查询预约订单分账记录
export const   bookOrderProfit=(bookId)=>urlPk.concat(`onsite/share/profit/record/${bookId}`)

// 共享报表日统计相关接口
export const shareReportDayStatistics = () => urlPk.concat('onsite/share/profit/dayStatistics');
export const shareReportDayList = () => urlPk.concat('onsite/share/profit/dayReport');

//预约记录
export const   bookRecord=()=>urlPk.concat('onsite/share/book/page');


//共享停车意见征集
export const   shareSuggestion=()=>urlPk.concat('parking/statisticsTable/page');

//共享停车意见征集统计

export const   shareSuggestionStatis=()=>urlPk.concat('parking/statisticsTable/getIsAgreeNum');

//共享停车 更新车位
export const   updateShareSpace=()=>urlPk.concat('onsite/share/update');

//共享停车 车位锁
export const 	shareLock=()=>urlPk.concat('onsite/share/getLockInfo');

//网关日志
export const   gatewayLog=()=>urlPk.concat('onsite/parkGatewayLog/infoPage');

//状态汇报
export const   searchStatusReport=()=>urlPk.concat('onsite/gatewayStatusReport/queryReportAddress');
export const   addStatusReport=()=>urlPk.concat('onsite/gatewayStatusReport/saveReportAddress');
export const   updateStatusReport=()=>urlPk.concat('onsite/gatewayStatusReport/updateReportAddress');

//都匀促销分类列表
export const   merchantClassList=()=>urlPk.concat('parking/discountsImg/page');
//都匀促销分类cud
export const   merchantClassCud=()=>urlPk.concat('parking/discountsImg');

//都匀查询所有分类
export const merchantClassAll=()=>urlPk.concat('parking/discounts/all');
//都匀促销优惠列表
export const   promotionDiscountList=()=>urlPk.concat('parking/discounts/page');

//都匀促销优惠详情
export const    promotionDiscountDetail=()=>urlPk.concat('parking/discounts');

//都匀促销优惠新增
export const   addPromotionDiscount=()=>urlPk.concat('parking/discounts');

//都匀促销优惠修改
export const   updatePromotionDiscount=()=>urlPk.concat('parking/discounts');

//都匀促销优惠删除
export const   delPromotionDiscount=()=>urlPk.concat('parking/discounts');

//小程序消息发布列表
export const   publishMessageList=()=>urlPk.concat('parking/advertise/adQuery');

//小程序消息发布cud
export const   publishMessageCud=()=>urlPk.concat('parking/advertise');

//物业车位上下架
export const   spacePublished=()=>urlPk.concat('onsite/share');

//共享停车信息待完善车位
export const   pendingSpaceList=()=>urlPk.concat('onsite/share/getNoEnough');

//共享停车信息待删除车位

export const   pendingSpaceDeleteList=()=>urlPk.concat('onsite/share/wechat/tobeDeleted');


//审核删除车位
export const   auditSpaceDelete=()=>urlPk.concat('onsite/share/wechat/deleteAudit');


//查询待审核车位
export const   pendingAuditSpaceList=()=>urlPk.concat('onsite/share/wechat/getPageByShareParkingSpace');

//批量开启地磁蓝牙功能
export const   batchOpenNbGeomagnetism=()=>urlPk.concat('parking/ctwing/bluetooth');

//共享停车:支付配置

export const   sharePaymentConfig=()=>urlPk.concat('parking/ccbPay');

//共享停车:支付配置查询
export const   sharePaymentConfigList=()=>urlPk.concat('parking/ccbPay/query');

//共享停车:分账配置查询
export const   shareSplitAccountConfigList=()=>urlPk.concat('onsite/share/splitByParking');


//都匀促销优惠启用禁用
// export const   enablePromotion=()=>urlPk.concat('parking/promotion/enable');

//手机验证码
  export const   getCaptcha=()=>urlPk.concat('app/appUser/getSmsCode');

//商户优惠券管理相关接口
//商户管理
export const merchantList = () => urlPk.concat('merchant/coupon/merchant/page');
export const merchantAdd = () => urlPk.concat('merchant/coupon/merchant');
export const merchantUpdate = () => urlPk.concat('merchant/coupon/merchant');
export const merchantDelete = () => urlPk.concat('merchant/coupon/merchant');
export const merchantCategories = () => urlPk.concat('merchant/coupon/category/all');
export const uploadImage = () => urlPk.concat('merchant/coupon/upload/image');

//领取规则管理
export const couponRuleList = () => urlPk.concat('merchant/coupon/rule/page');
export const couponRuleAdd = () => urlPk.concat('merchant/coupon/rule');
export const couponRuleUpdate = () => urlPk.concat('merchant/coupon/rule');
export const couponRuleDelete = () => urlPk.concat('merchant/coupon/rule');
export const couponRuleToggleStatus = () => urlPk.concat('merchant/coupon/rule/toggleStatus');
export const timeConfigList = () => urlPk.concat('merchant/coupon/rule/timeConfig');
export const timeConfigSave = () => urlPk.concat('merchant/coupon/rule/timeConfig/save');

//优惠券管理
export const couponList = () => urlPk.concat('merchant/coupon/page');
export const couponAdd = () => urlPk.concat('merchant/coupon');
export const couponUpdate = () => urlPk.concat('merchant/coupon');
export const couponDelete = () => urlPk.concat('merchant/coupon');
export const couponAudit = () => urlPk.concat('merchant/coupon/audit');
export const couponToggleShelf = () => urlPk.concat('merchant/coupon/toggleShelf');

//商家优惠券
//商户分类
export const shopMerchantCategoryList = () => urlPk.concat('onsite/couponCategory/findPage');
//新增商户分类
export const shopMerchantCategoryAdd = () => urlPk.concat('onsite/couponCategory');
//修改商户分类
export const shopMerchantCategoryEdit = () => urlPk.concat('onsite/couponCategory');
//查询所有商家分类
export const shopMerchantCategoryAll = () => urlPk.concat('onsite/couponCategory/all');


//商家列表
export const shopMerchantList = () => urlPk.concat('onsite/couponMerchant/findAuditStatus');

//商家审核
export const shopMerchantAudit = () => urlPk.concat('onsite/couponMerchant');
//商家审核1
export const shopMerchantAuditNew = () => urlPk.concat('onsite/couponMerchant/auditCouponMerchant');

//给商家分类
export const shopMerchantCategory = () => urlPk.concat('onsite/couponMerchant/category');

//商家统计
export const shopMerchantCount = () => urlPk.concat('onsite/couponMerchant/statistics');

//商家上下架
export const shopMerchantShelf = () => urlPk.concat('onsite/couponMerchant/shelf');

//商家排序
export const shopMerchantSort = () => urlPk.concat('onsite/couponMerchant/sort');

//商家优惠券
export const shopCouponList = () => urlPk.concat('onsite/coupon/findAuditStatus');

//查询单个优惠券
export const shopCoupon = () => urlPk.concat('onsite/coupon');

//商家优惠券审核
export const shopCouponAudit = () => urlPk.concat('onsite/coupon');
//商家优惠券审核新
export const shopCouponAuditNew = () => urlPk.concat('onsite/coupon/auditCoupon');
//商家优惠券统计
export const shopCouponCount = () => urlPk.concat('onsite/coupon/plateformStatistics');

//查询领取规则
export const shopCouponRule = () => urlPk.concat('onsite/couponRuleConfig/rule');
//修改领取规则
export const shopCouponRuleEdit = () => urlPk.concat('onsite/couponRuleConfig/updateRule');

//查询抽奖规则配置
export const couponLotteryConfigSelect = () => urlPk.concat('onsite/couponLotteryConfig/selectByCoupon');
//抽奖规则配置（创建和更新）
export const couponLotteryConfig = () => urlPk.concat('onsite/couponLotteryConfig');

//领取记录
export const shopCouponReceiveList = () => urlPk.concat('onsite/couponUser/platformRecord');

//所有车场（路边，停车场）
export const allParkingList = () => urlPk.concat('onsite/parking/all');

//开启或关闭停车场优惠券
export const couponSwitch = () => urlPk.concat('onsite/coupon/couponParking');

//车场追缴路边欠费明细（20260723新增）
export const recoveryRoadArrearsPageAPI = () => urlPk + 'onsite/payOrderOnsiteRoadside/page';

/*echarts*/

export const line_box = function (opt) {
    var option = {
        color: opt.color || ['#2a9dec', '#5edbff', '#ff9434', '#5ab4b4', '#b35ab4', '#ff5858', '#ff9873'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: opt.mtype || 'line'
            },
            formatter: opt.formatter || '{b}<br />{a}: {c}'
        },
        legend: {
            data: opt.item,
            left: opt.left || 'center',
            orient: opt.orient || 'horizontal'
        },
        toolbox: {
            show: true,
            right: 15,
            feature: {
                mark: {
                    show: true
                },
                // dataView : {show: true, readOnly: false},
                magicType: {
                    show: true,
                    type: opt.tbmagic || ['line', 'bar', 'stack', 'tiled']
                },
                restore: {
                    show: true
                }
                // saveAsImage : {show: true}
            }
        },
        calculable: true,
        xAxis: [{
            name: opt.xy[0],
            type: 'category',
            data: opt.xaxis,
            // max:5,
            axisLabel: {
                interval: opt.interval || "auto"
            },
            axisTick: {
                show: false
            }
        }],
        yAxis: [{
            name: opt.xy[1],
            type: 'value',
            axisTick: {
                show: false
            }
        }],
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: opt.dzoom || 20,
            disabled: false
        }, {
            start: 0,
            end: opt.dzoom || 20,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: opt.series
    };
    return option;
}

export const line_box_category = function (opt) {
    var option = {
        color: opt.color || ['#2a9dec', '#5edbff', '#ff9434', '#5ab4b4', '#b35ab4', '#ff5858', '#ff9873'],
        tooltip: {
            show: false,
            trigger: 'axis',
            axisPointer: {
                type: opt.mtype || 'line'
            },
            formatter: opt.formatter || '{b}<br />{a}: {c}'
        },
        legend: {
            data: opt.item,
            left: opt.left || 'center',
            orient: opt.orient || 'horizontal'
        },
        toolbox: {
            show: true,
            right: 15,
            feature: {
                mark: {
                    show: true
                },
                // dataView : {show: true, readOnly: false},
                magicType: {
                    show: true,
                    type: opt.tbmagic || ['line', 'bar', 'stack', 'tiled']
                },
                restore: {
                    show: true
                }
                // saveAsImage : {show: true}
            }
        },
        calculable: true,
        xAxis: [{
            name: opt.xy[0],
            type: 'category',
            data: opt.xaxis,
            // max:5,
            axisLabel: {
                interval: opt.interval || "auto"
            },
            axisTick: {
                show: false
            }
        }],
        yAxis: [{
            name: opt.xy[1],
            type: 'value',
            minInterval: 1,
            boundaryGap: false,
            // data : ['异常','正常'],
            axisLabel: {
                formatter: opt.ylabel || function (value, index) {
                    if (value == 1) {
                        return '开';
                    } else {
                        return '关';
                    }

                }
            },
            axisTick: {
                show: false
            }
        }],
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: opt.dzoom || 20,
            disabled: false
        }, {
            start: 0,
            end: opt.dzoom || 20,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
                color: '#fff',
                shadowBlur: 3,
                shadowColor: 'rgba(0, 0, 0, 0.6)',
                shadowOffsetX: 2,
                shadowOffsetY: 2
            }
        }],
        series: opt.series
    };
    return option;
}

export const newbar_box = function (opt) {
    var option = {
        color: ['#299cec', '#ce89fe', '#ff9434', '#5eddc0', '#5ab4b4'],
        title: {
            text: opt.title || "",
            left: 'right',
            textStyle: {
                color: "#299ceb",
                fontSize: "12",
                fontWeight: "normal"
            }
        },
        tooltip: {
            show: false || opt.showTool,
            trigger: 'axis',
            axisPointer: {
                type: opt.mtype || 'line'
            },
            formatter: opt.formatter || '{b}' + opt.units[0] + '<br />{a0}: {c0}' + opt.units[1] + '<br />{a1}: {c1}' + opt.units[1]
        },
        legend: {
            data: opt.item,
            left: 'center',
            orient: opt.orient || 'horizontal'
        },
        grid: {
            top: 30,
            left: '1%',
            right: '50',
            bottom: 30,
            containLabel: true
        },
        /*toolbox: {
            show : true,
            right: 15,
            feature : {
                mark : {show: true},
                dataView : {show: true, readOnly: false},
                magicType : {show: true, type: opt.tbmagic||['line', 'bar', 'stack', 'tiled']},
                restore : opt.restore||{show:true}
                saveAsImage : {show: true}
            }
        },*/
        calculable: true,
        xAxis: [{
            name: opt.xy[0],
            type: 'category',
            data: opt.xaxis,
            max: opt.max || 14,
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0,
                rotate: 0
            }
        }],
        yAxis: [{
            name: opt.xy[1],
            type: 'value',
            axisTick: {
                show: false
            }
        }],
        label: {
            normal: {
                show: true,
                position: 'top'
            }
        },
        dataZoom: [{
            type: 'inside',
            start: 0,
            end: opt.dzoom || 100,
            disabled: opt.diszoom ? false : true
        }],
        series: opt.series
    };
    return option;
}

export const newline_box = function (opt) {
    var option = {
        color: opt.color || ['#cf89ff', '#5edbff', '#ff9434', '#5ab4b4', '#b35ab4', '#ff5858', '#ff9873'],
        title: {
            text: opt.title || "",
            left: 'right',
            textStyle: {
                color: "#299ceb",
                fontSize: "12",
                fontWeight: "normal"
            }
        },
        tooltip: {
            trigger: 'item',
            padding: [5, 10],
            axisPointer: {
                type: opt.mtype || 'line'
            },
            formatter: opt.formatter || '{b}' + opt.units[0] + '<br />{a0}: {c0}' + opt.units[1] + '<br />{a1}: {c1}' + opt.units[1]
        },
        legend: {
            data: opt.item,
            width: "85%",
            left: opt.left || 'center',
            orient: opt.orient || 'horizontal'
        },
        grid: {
            top: opt.gtop || 30,
            left: '1%',
            right: '50',
            bottom: 20,
            containLabel: true
        },
        calculable: true,
        xAxis: [{
            name: opt.xy[0],
            type: 'category',
            data: opt.xaxis,
            boundaryGap: false,
            max: 11,
            axisLabel: {
                interval: opt.interval || "auto"
            },
            axisTick: {
                show: false
            }
        }],
        yAxis: [{
            name: opt.xy[1],
            type: 'value',
            axisLabel: {
                formatter: function (value, index) {
                    // 格式化成月/日，只在第一个刻度显示年份
                    if (index === 0) {
                        return value;
                    }
                    return value + ' %';
                }
            },
            axisTick: {
                show: false
            }
        }],
        series: opt.series
    };

    return option;
}
export const datazoom = function (datalength) {
    var zoom = 20;
    if (datalength <= 13) {
        zoom = 100;
    } else {
        zoom = parseInt(100 * 13 / datalength);
        if (zoom == 0) {
            zoom = 1;
        }
    }
    return zoom;
}

export const loading = {
    text: '',
    color: '#c23531',
    textColor: '#000',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    zlevel: 0
};



/*Map*/
export const setMapEvent = function (map) {
    map.enableScrollWheelZoom();
    map.enableKeyboard();
    map.enableDragging();
    map.enableDoubleClickZoom();
};
export const addMapControl = function (map) {
    var scaleControl = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
    });
    scaleControl.setUnit(BMAP_UNIT_METRIC);
    map.addControl(scaleControl);
    var navControl = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        type: 3
    });
    map.addControl(navControl);
    var overviewControl = new BMap.OverviewMapControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        isOpen: false
    });
    map.addControl(overviewControl);

    /*var size = new BMap.Size(40, 10);
    var cityListControl=new BMap.CityListControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        offset: size
    });
    map.addControl(cityListControl);*/
};
export const tests = function (map, mark) {
    console.log(mark)
    new BMapLib.MarkerClusterer(map, {
        mark: mark
    });
}

export const createTag = function (map, marker, rows) {

    var opts = {
        width: 350,
        height: 200
    };
    var content = "<h1 style='width:100%;height:30px;border-radius:10px;line-heigt:30px;font-size:20px;text-align:center;color:#00CC33'>" + rows.parkingName + "</h1><ul style='border-radius:10px'><li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;color:#666;font-weight:bold'>地址:" + rows.parkingAddress + "</li>" +
        // "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>总停车位:" + rows.totalNum + "</li>" +
        // "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>剩余停车位:" + rows.leftNum + "</li>" +
        // "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>停车场层数:" + rows.parkingLayer + "</li>" +
        // "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>首小时收费:" + rows.firstHourPrice + "</li>" +
        "</ul>";
    //给标记添加点击事件以及显示窗口信息（天地图）
    // 尝试不同的InfoWindow创建方式（兼容天地图4.0）
    var infoWindow = null;
    try {
        // 方式1：先创建，再设置内容
        if (T.InfoWindow) {
            infoWindow = new T.InfoWindow(opts);
            if (typeof infoWindow.setContent === 'function') {
                infoWindow.setContent(content);
            } else if (typeof infoWindow.setHTML === 'function') {
                infoWindow.setHTML(content);
            } else {
                // 如果setContent不存在，尝试在构造函数中传入content
                opts.content = content;
                infoWindow = new T.InfoWindow(opts);
            }
        }
    } catch (e) {
        console.warn('创建InfoWindow失败，尝试备用方式:', e);
        // 备用方式：直接在构造函数中传入content
        try {
            opts.content = content;
            infoWindow = new T.InfoWindow(opts);
        } catch (e2) {
            console.error('创建InfoWindow完全失败:', e2);
            return; // 如果创建失败，直接返回
        }
    }
    
    if (!infoWindow) {
        console.error('InfoWindow创建失败');
        return;
    }
    
    // 保存marker的坐标位置（使用rows中的坐标，因为天地图4.0可能没有getPosition方法）
    var markerLng = rows.pointLng;
    var markerLat = rows.pointLat;
    var markerPoint = new T.LngLat(markerLng, markerLat);
    
    // 当前打开的信息窗口引用
    var currentInfoWindow = null;
    
    // 关闭信息窗口的辅助函数（兼容不同版本的API）
    function closeInfoWindow(infoWin) {
        if (!infoWin) return;
        try {
            if (typeof infoWin.close === 'function') {
                infoWin.close();
            } else if (typeof infoWin.hide === 'function') {
                infoWin.hide();
            } else if (typeof map.closeInfoWindow === 'function') {
                map.closeInfoWindow(infoWin);
            } else if (typeof map.removeInfoWindow === 'function') {
                map.removeInfoWindow(infoWin);
            } else if (typeof map.close === 'function') {
                map.close(infoWin);
            }
        } catch (e) {
            console.warn('关闭信息窗口失败:', e);
        }
    }
    
    // 打开信息窗口的辅助函数（兼容不同版本的API）
    function openInfoWindow(infoWin, mapInstance, position) {
        if (!infoWin || !position) return;
        try {
            // 尝试不同的打开方法
            // 方式1：只传位置参数（天地图4.0可能只需要位置）
            if (typeof infoWin.open === 'function') {
                try {
                    // 先尝试只传位置
                    infoWin.open(position);
                } catch (e1) {
                    // 如果失败，尝试传map和位置
                    try {
                        infoWin.open(mapInstance, position);
                    } catch (e2) {
                        console.warn('infoWin.open失败:', e2);
                    }
                }
            } else if (typeof infoWin.show === 'function') {
                try {
                    infoWin.show(position);
                } catch (e1) {
                    try {
                        infoWin.show(mapInstance, position);
                    } catch (e2) {
                        console.warn('infoWin.show失败:', e2);
                    }
                }
            } else if (typeof mapInstance.openInfoWindow === 'function') {
                mapInstance.openInfoWindow(infoWin, position);
            } else if (typeof mapInstance.addInfoWindow === 'function') {
                mapInstance.addInfoWindow(infoWin, position);
            } else if (typeof infoWin.setPosition === 'function' && typeof mapInstance.addOverlay === 'function') {
                // 天地图4.0可能需要先设置位置，然后添加到地图
                infoWin.setPosition(position);
                mapInstance.addOverlay(infoWin);
            } else if (typeof infoWin.setPosition === 'function' && typeof mapInstance.addLayer === 'function') {
                infoWin.setPosition(position);
                mapInstance.addLayer(infoWin);
            } else {
                console.warn('无法打开信息窗口，未找到合适的方法');
            }
        } catch (e) {
            console.warn('打开信息窗口失败:', e);
        }
    }
    
    // 获取marker位置的辅助函数（兼容不同版本的API）
    function getMarkerPosition(marker) {
        try {
            // 优先使用保存的坐标
            if (markerPoint) {
                return markerPoint;
            }
            // 尝试不同的方法获取位置
            if (typeof marker.getPosition === 'function') {
                return marker.getPosition();
            } else if (typeof marker.getLngLat === 'function') {
                return marker.getLngLat();
            } else if (typeof marker.getPoint === 'function') {
                return marker.getPoint();
            } else if (marker.lngLat) {
                return marker.lngLat;
            } else if (marker.point) {
                return marker.point;
            }
            // 如果都失败，返回保存的坐标
            return markerPoint;
        } catch (e) {
            console.warn('获取marker位置失败:', e);
            return markerPoint;
        }
    }
    
    // 点击显示信息窗口
    marker.addEventListener("click", function () {
        // 如果已有信息窗口打开，先关闭
        if (currentInfoWindow) {
            closeInfoWindow(currentInfoWindow);
            // 如果点击的是同一个marker，关闭后不再打开（实现切换效果）
            if (currentInfoWindow === infoWindow) {
                currentInfoWindow = null;
                return;
            }
        }
        currentInfoWindow = infoWindow;
        var position = getMarkerPosition(marker);
        openInfoWindow(infoWindow, map, position);
    });
}









export const addMapOverlay = function (map, markers) {
    console.log(markers)
    for (var index = 0; index < markers.length; index++) {

        var point = new BMap.Point(
            //经纬度
            markers[index].pointLng,
            markers[index].pointLat);
        //创建标注        
        var marker = new BMap.Marker(
            point, {
                icon: new BMap.Icon(
                    markers[index].webMapPicture ? 'http://slwl-parking.oss-cn-shenzhen.aliyuncs.com/iotExper/' + markers[index].webMapPicture : require('@/assets/images/mark.png'),
                    new BMap.Size(26, 36), {
                        imageOffset: new BMap.Size(0, 0),
                        imageSize: new BMap.Size(26, 36)
                    })
            });
        // console.log("marker:" + marker);

        var label = new BMap.Label(markers[index].deviceName, {
            offset: new BMap.Size(25, 5)
        });
        var opts = {
            width: 350,
            height: 200,
            title: '', //markers[index].parkingName,
            // title : markers[index].typeName,
            enableMessage: false,
            //message:markers[index].parkingAddress
        };

        //var content='sss';

        var content = "<h1 style='width:100%;backgruond-color:#ccc;height:30px;font-size:20px;text-align:center;'>" + markers[index].parkingName + "</h1><ul><li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>地址:" + markers[index].parkingAddress + "</li>" +
            "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>总停车位:" + markers[index].totalNum + "</li>" +
            "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>剩余停车位:" + markers[index].leftNum + "</li>" +
            "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>停车场层数:" + markers[index].parkingLayer + "</li>" +
            "<li style='border-bottom:solid 1px #ccc;height:30px;line-height:30px;'>首小时收费:" + markers[index].firstHourPrice + "</li>" +
            "</ul>";

        /*if(Boolean(markers[index].controlClass==1)){
            content='<div class="info-marker"><p><span>'+markers[index].address+'</span></p><div class="history-btn"><button><a href="#/main/hisdataTemp?typeCode='+markers[index].typeCode+'&devSn='+markers[index].onerankdevDevSn+'&controlClass='+markers[index].controlClass+'&deviceName='+markers[index].deviceName+'">历史数据</a></button></div></div>';
        }else{
            content='<div class="info-marker"><p><span>'+markers[index].address+'</span></p></div>';
        }*/
        //创建信息窗口对象
        var infoWindow = new BMap.InfoWindow(content, opts);
        // marker.setLabel(label);

        addClickHandler(marker, infoWindow, markers[index].deviceName, markers[index].devId);
        //将标注添加到地图
        map.addOverlay(marker);

    };
};
export const addMapOverlayl = function (n, m, map, typeImg) {
    var markers = {
        content: "南山数字文化产业基地西塔楼1009室",
        title: "公司地址",
        imageOffset: {
            width: 0,
            height: 0
        },
        position: {
            lng: m,
            lat: n

        }
    };

    var point = new BMap.Point(markers.position.lng, markers.position.lat);
    var marker = new BMap.Marker(
        point, {
            icon: new BMap.Icon(
                (typeImg && typeImg != "null") ? 'http://slwl-parking.oss-cn-shenzhen.aliyuncs.com/iotExper/' + typeImg : require('@/assets/images/mark.png'),
                new BMap.Size(26, 36), {
                    imageOffset: new BMap.Size(0, 0),
                    imageSize: new BMap.Size(26, 36)
                })
        });

    var allOverlay = map.getOverlays();
    for (var i = 0; i < allOverlay.length; i++) {
        map.removeOverlay(allOverlay[i]);
    }
    map.addOverlay(marker);
}

export const addClickHandler = function (target, window, id, name) {

    target.addEventListener("click", function () {
        target.openInfoWindow(window);
        // console.log(id, name);
        // setTimeout(function(){
        //  $("#equipData").val("ssss")
        // }, 2000)

    });
}

export const customOverlay = function (point, text, markerImg, fontColor) {
    this._point = point;
    this._text = text;
    this._color = fontColor;
    this._bgImg = markerImg;
}

//积分管理
//积分规则列表
export const queryPointsRuleList = () => urlPk.concat(`parking/integralRule/page`)
//单个积分规则
export const pointsRuleOne = () => urlPk.concat(`parking/integralRule`)
//发布或废除积分规则
export const pointsRuleOper = () => urlPk.concat(`parking/integralRule/oper`)
//积分使用记录
export const queryPointsUsedRecord = () => urlPk.concat(`parking/integralRecord/queryByPageExt`)